(() => {
  if (window.bbHeaderFlyoutsLoaded) return;
  window.bbHeaderFlyoutsLoaded = true;
  const desktop = matchMedia('(min-width: 1024px)');
  const hover = matchMedia('(hover: hover) and (pointer: fine)');
  const selector = '.bb-category-nav__details, .bb-taxonomy-group';
  const controllers = new Map();
  function init(nav) {
    if (controllers.has(nav) || !('showPopover' in HTMLElement.prototype)) return;
    const details = [...nav.querySelectorAll(selector)];
    const panel = d => d.querySelector(':scope > ul');
    const summary = d => d.querySelector(':scope > summary');
    const parent = d => d.parentElement.closest(selector);
    const level = d => parent(d) ? level(parent(d)) + 1 : 0;
    const root = d => parent(d) ? root(parent(d)) : d;
    let leaveTimer;
    let frame;
    function close(d) {
      [...d.querySelectorAll(selector)].reverse().forEach(close);
      const list = panel(d);
      if (list?.matches(':popover-open')) list.hidePopover();
      d.open = false;
    }
    function closeAll() { details.filter(d => !parent(d)).forEach(close); }
    function position() {
      if (!desktop.matches) return;
      const open = details.filter(d => d.open && panel(d).matches(':popover-open')).sort((a,b)=>level(a)-level(b));
      const width = Math.min(280, Math.floor((innerWidth - 40) / 3));
      const positions = new Map();
      for (const d of open) {
        const list = panel(d), trigger = summary(d).getBoundingClientRect();
        list.style.width = `${width}px`;
        const owner = parent(d);
        let left;
        if (owner) left = positions.get(owner) + width + 4;
        else {
          const columns = Math.max(...details.filter(x => root(x) === d).map(x => level(x))) + 1;
          left = Math.max(16, Math.min(trigger.left, innerWidth - 16 - columns * (width + 4)));
        }
        const height = list.getBoundingClientRect().height;
        const desiredTop = owner ? trigger.top : trigger.bottom + 4;
        list.style.left = `${left}px`;
        positions.set(d, left);
        list.style.top = `${Math.max(16, Math.min(desiredTop, innerHeight - height - 16))}px`;
      }
    }
    function queuePosition() { cancelAnimationFrame(frame); frame = requestAnimationFrame(position); }
    function open(d) {
      if (!desktop.matches) return;
      details.filter(x => x !== d && parent(x) === parent(d)).forEach(close);
      d.open = true;
      const list = panel(d);
      if (!list.matches(':popover-open')) list.showPopover();
      queuePosition();
    }
    for (const d of details) {
      d.addEventListener('toggle', () => {
        if (!desktop.matches) return;
        if (d.open) open(d); else { close(d); queuePosition(); }
      });
      summary(d).addEventListener('pointerenter', () => {
        if (hover.matches && desktop.matches) { clearTimeout(leaveTimer); open(d); }
      });
    }
    nav.addEventListener('pointerover', () => clearTimeout(leaveTimer));
    nav.addEventListener('pointerout', e => {
      if (desktop.matches && hover.matches && !nav.contains(e.relatedTarget)) leaveTimer = setTimeout(closeAll, 240);
    });
    nav.addEventListener('keydown', e => {
      if (!desktop.matches) return;
      const d = e.target.closest(selector);
      if (!d) return;
      if (e.key === 'ArrowRight' && e.target === summary(d)) {
        e.preventDefault(); open(d); panel(d).querySelector('a, summary')?.focus();
      } else if (e.key === 'ArrowLeft' || e.key === 'Escape') {
        e.preventDefault(); e.stopPropagation(); close(d); summary(d).focus(); queuePosition();
      }
    });
    nav.addEventListener('focusout', e => { if (!nav.contains(e.relatedTarget)) closeAll(); });
    function refresh() {
      closeAll();
      for (const d of details) {
        const list = panel(d);
        list.removeAttribute('style');
        if (desktop.matches) list.setAttribute('popover','manual'); else list.removeAttribute('popover');
      }
      if (desktop.matches) nav.dataset.flyoutsReady = 'true'; else delete nav.dataset.flyoutsReady;
    }
    controllers.set(nav, { refresh, closeAll, queuePosition });
    refresh();
  }
  function boot() {
    for (const [nav, controller] of controllers) if (!nav.isConnected) { controller.closeAll(); controllers.delete(nav); }
    document.querySelectorAll('.header__menu').forEach(init);
  }
  document.addEventListener('pointerdown', e => { for (const [nav,c] of controllers) if (!nav.contains(e.target)) c.closeAll(); });
  window.addEventListener('resize', () => { for (const c of controllers.values()) c.queuePosition(); });
  window.addEventListener('scroll', () => { for (const c of controllers.values()) c.queuePosition(); }, { passive: true, capture: true });
  desktop.addEventListener('change', () => { for (const c of controllers.values()) c.refresh(); });
  document.addEventListener('shopify:section:load', boot);
  boot();
})();
